module.exports = __webpack_public_path__ + "static/media/Disputes.5bae060f.svg";